import { useRef } from 'react'

import { useNavigate } from 'react-router-dom'

import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import { format } from '@sequencehq/utils/dates'

import { getCurrentMonthDateRange } from 'Invoices/utils'
import { DATE_FORMAT_API } from 'Invoices/constants'
import { invoicePaths } from 'Invoices/invoices.router'
import { useCreateInvoice } from './useCreateInvoice'

export const useCreateInvoiceWithCustomerId = () => {
  const navigate = useNavigate()
  const createInvoice = useCreateInvoice()
  const started = useRef(false)

  return async (customerId: string) => {
    if (started.current) {
      return
    }

    started.current = true

    const accountSettingsReq =
      await dashboard20240730Client.getSequenceAccountSettings()

    if (accountSettingsReq.error || !accountSettingsReq.data) {
      throw new Error('Unable to get account settings')
    }

    const allCurrencies = accountSettingsReq.data.enabledCurrencies
    const defaultCurrency = allCurrencies.at(0)

    if (!defaultCurrency) {
      throw new Error('No default currency available')
    }

    const now = new Date()
    const currentMonthDateRange = getCurrentMonthDateRange(now)

    const invoice = await createInvoice({
      customerId,
      currency: defaultCurrency,
      billingPeriod: {
        start: format(currentMonthDateRange.startDate, DATE_FORMAT_API),
        endInclusive: format(currentMonthDateRange.endDate, DATE_FORMAT_API)
      },
      paymentOptions: ['BANK_TRANSFER']
    })

    if (!invoice) {
      throw new Error('Unable to create invoice')
    }

    navigate(invoicePaths.creationFlow(invoice.id), {
      replace: true,
      preventScrollReset: true
    })
  }
}
